module.exports = __webpack_public_path__ + "img/flexepin.bff605ea.png";